export function run(){
    return {
        jquery(){
            $(function(){
                $('.new-password, .password').on('click', '.input-group i.fa-eye', function(){
                    if($(this).parents('.input-group').find('input').attr('type') == 'password'){
                        $(this).parents('.input-group').find('input').attr('type', 'text');
                    }else{
                        $(this).parents('.input-group').find('input').attr('type', 'password');
                    }
                });
                
                $('.new-password').on('keyup', 'input', function(){
                    var list = $(this).parents('.new-password').find('ul');
                    if($(this).val().search(/[a-z]+/) != -1){
                        list.find('li.step-1').addClass('checked');
                    }else{
                        list.find('li.step-1').removeClass('checked');
                    }
                    if($(this).val().search(/[A-Z]+/) != -1){
                        list.find('li.step-2').addClass('checked');
                    }else{
                        list.find('li.step-2').removeClass('checked');
                    }
                    if($(this).val().search(/[0-9]+/) != -1){
                        list.find('li.step-3').addClass('checked');
                    }else{
                        list.find('li.step-3').removeClass('checked');
                    }

                    if($(this).val().length >= 8){
                        list.find('li.step-4').addClass('checked');
                    }else{
                        list.find('li.step-4').removeClass('checked');
                    }
                });
            });
        }
    }
}
